import './App.css';
import Box from '@mui/material/Box';
import Header from './components/Header';
import Footer from './components/Footer';
import Banner from './components/Content/1Banner';
import About from './components/Content/2About';
import Program from './components/Content/3Program';
import Rotation from './components/Content/4Rotation';
import Looking from './components/Content/5Looking';
import Process from './components/Content/6Process';
import FAQ from './components/Content/7FAQ';
import Testimonial from './components/Content/8Testimonial';

function App() {
  return (
    <div className="App">
      <Header/>
      <Box className='container finance'>
        <Banner />
        <About />
        <Program />
        <Rotation />
        <Looking />
        <Process />
        <FAQ />
        <Testimonial />
      </Box>
      <Footer/>
    </div>
  ); 
}

export default App;
